import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resGetAllPayment {
  success: boolean,
  message: string,
  result: AllPayment
}

interface Payment {
  success: boolean,
  message: string,
  result: []
}

export interface AllPayment {
  PAYMENT_ID: string,
  REF_ID: string,
  CREATE_DATE: string,
  USER_ID: string,
  TYPE: string,
  UPDATE_DATE: string,
  PRICE: number,
  STATUS_PAYMENT: string,
  EXP_DATE: string,
  PAYMENT_DATE: string,
  PAYMENT_GROUP: string,
  USERNAME: string,
  APPROVE_NAME: string
}

interface resGetDetailPaymentById {
  success: boolean,
  message: string,
  result: [
    {
      PAYMENT_ID: string,
      REF_ID: string,
      CREATE_DATE: Date,
      USER_ID: string,
      TYPE: string,
      UPDATE_DATE: Date,
      PRICE: number,
      STATUS_PAYMENT: string,
      EXP_DATE: Date,
      PAYMENT_NAME: string,
      USERNAME: string,
      Detail: [{
        TRANS_ID: string,
        PAYMENT_ID: string,
        PAYMENT_TYPE: string,
        PRICE: number,
        APPROVE_ID: string,
        CREDIT_NUMBER: string,
        CREDIT_NAME: string,
        CREDIT_DATE: string,
        CREDIT_MONTH: string,
        TRANFER_DATE: Date,
        TRANFER_HR: string,
        TRANFER_MIN: string,
        TRANFER_PRICE: number,
        TRANFER_PIC: string,
        STATUS: string,
        TRANFER_PIC_ORIGINAL: string,
        USER_ID: string,
        REMARK: string,
        UPDATE_DATE: Date
      }]
    }
  ]
}

interface resGetPaymentReport {
  success: boolean,
  message: string,
  result: [
    {
      APPROVE_ID: string,
      CREATE_DATE: string,
      CREDIT_DATE: string,
      CREDIT_MONTH: string,
      CREDIT_NAME: string,
      CREDIT_NUMBER: string,
      EMAIL: string,
      EXP_DATE: string,
      PAYMENT_ID: string,
      PAYMENT_NAME: string,
      PAYMENT_TYPE: string,
      PRICE: number,
      REF_ID: string,
      REMARK: string,
      STATUS: string,
      STATUS_PAYMENT: string,
      TRANFER_DATE: string,
      TRANFER_HR: string,
      TRANFER_MIN: string,
      TRANFER_PIC: string,
      TRANFER_PRICE: number,
      TRANS_ID: string,
      TYPE: string,
      USERNAME: string,
      USER_ID: string,
      NAME: string,
      ADDRESS: string,
      PAYMENT_PHONENUMBER: string,
      TAX_NO: string,
    }
  ]
}

interface resGetReciept {

  success: boolean;
  message: string;
  result: [
    {
      PAYMENT_ID: string,
      PAYMENT_NAME: string,
      PAYMENT_TYPE: string,
      PAYMENT_PRICE: number,
      PAYMENT_DATE: string,
      SIGNATURE_BASE64: string
      NAME: string,
      PHONENUMBER: string,
      TAX_NO: string,
      ADDRESS: string,
      SPECIALPRICE: number,
      STANDARTPRICE: number,
      SIGNATURE_NAME: string,
      SIGNATURE_JOBTITAL: string,
      RECEIPT_ID: string,
      CARD_NO: string,
      REMARK_PRICE: string,
    }
  ];
}

interface resGetSignature {

  success: boolean;
  message: string;
  result: [
    {
      ID: number,
      NAME: string,
      JOB_TITAL: string,
      SIGNATURE_ORIGINAL: string,
      SIGNATURE: string,
      CREATE_DATE: string,
      UPDATE_DATE: string,
      base64: string
    }
  ];
}


@Injectable({
  providedIn: 'root'
})
export class PaymentManagementService {
  token: string = null;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getAllPayment(accountId) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetAllPayment>(environment.URL + `/manage_admin/getAllPayment?ACCOUNTING_ID=${accountId}`, { headers: headers })
  }

  getDetailPaymentById(pid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetDetailPaymentById>(environment.URL + '/manage_admin/getDetailPaymentById?PAYMENT_ID=' + pid, { headers: headers })
  }

  getDetailConfirmSlip(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDetailPaymentById>(environment.URL + '/manage_admin/getDetailConfirmSlip', body, { headers: headers })
  }

  confirmPayment(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<Payment>(environment.URL + '/manage_admin/confirmPayment', body, { headers: headers })
  }

  getPaymentReport(body) {
    const headers = new HttpHeaders({ Authorization: this.token })
    // // console.log(body);

    return this.http.post<resGetPaymentReport>(environment.URL + '/manage_admin/getPaymentReport', body, { headers: headers })
  }

  getReceiptById(pid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetReciept>(environment.URL + '/receipt/getReceiptById?PAYMENT_ID=' + pid, { headers: headers })
  }

  getSignature() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetSignature>(environment.URL + '/manage_admin/getSignature', { headers: headers })
  }

  updateSignature(value) {
    let formData = new FormData;
    const headers = new HttpHeaders({ Authorization: this.token })
    // console.log(value);
    formData.append('NAME', value.name);
    formData.append('JOB_TITAL', value.title);
    formData.append('SIGNATURE_PIC', value.img);

    return this.http.post<resGetPaymentReport>(environment.URL + '/manage_admin/updateSignature', formData, { headers: headers })
  }
  
  updatePaymentByTransId(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<any>(environment.URL + '/manage_admin/updatePaymentByTransId', body, { headers: headers })
  }
}
